import styled from '@emotion/styled';
import { COLORS3, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const TertiaryNavWrapper = styled.div`
  display: flex;
  column-gap: ${SPACING.S24};
  padding: 18px ${SPACING.LG};
  justify-content: center;
  border-top: 1px solid ${COLORS3.BLACK_030};
  align-items: center;
  height: 56px;
  grid-column: span 2;
  // fix for NavMapper z-index
  z-index: -3;

  .nav-dropdown__chevron {
    ${MEDIA_QUERY.EXCLUDE_DESKTOP_LG} {
      display: none;
    }
  }
`;
